module.exports = __webpack_public_path__ + "static/media/CircleCheck.cf6c5deb.svg";